<template>
	<div  class="sa-tab-scroll">
		<b-card v-for="(section, index) in sections" class="sa-card" :header="section.sezioneTitolo" header-tag="header" footer-tag="footer" :key="index">
			<!-- <p @click="onClickSisto">Sisto {{ formData }}</p> -->
			<b-row  v-if="formData" :key="keyIndex">
				<br />
					<b-col  v-for="(element, index) in getJsonForm(section)" :cols="element.cols" :xs="element.xs" :sm="element.sm" :md="element.md" :lg="element.lg" :xl="element.xl" :key="index">
						<label class="sa-label-data" v-if="element.label != null|| element.label != '' "> 
                            {{ element.label }}:</label>
						<template v-if="!isView">
							<template v-if="element.type === 'input'">
								<template v-if="element.typedetail">
								<b-form-input v-model="formData[element.modelName]"></b-form-input>
								</template>
								
								<template v-else>
									<b-form-input :type="element.typedetail" v-model="formData[element.modelName]"></b-form-input>
								</template>
							</template>
							<template v-if="element.type === 'datepicker'">
								<template v-if="element.typedetail">
									<template v-if="element.typedetail=='datetime'">
										<date-picker :format="'DD/MM/YYYY HH:mm'" 
										value-type="timestamp" v-model="formData[element.modelName]" :key="formData[element.modelName]" 
										type="datetime"></date-picker>
									</template>
								</template>
									<template v-else>
										<date-picker :format="'DD/MM/YYYY'" value-type="timestamp" v-model="formData[element.modelName]" :key="formData[element.modelName]" type="date"></date-picker>
									</template>
								
							</template>
							<template v-if="element.type === 'select'">
								<b-form-select v-model="formData[element.modelName]" :options="element.dataOptions" :value="null" value-field="value" text-field="text" @change="onChange(element)">
									<template #first>
										<b-form-select-option :value="null" disabled> - Seleziona Valore - </b-form-select-option>
									</template>
								</b-form-select>
							</template>
							<template v-if="element.type === 'textarea'">
								<b-form-textarea v-model="formData[element.modelName]" rows="7"></b-form-textarea>
							</template>
							<template v-if="element.type === 'checkbox'">
								<b-form-checkbox v-model="formData[element.modelName]" @change="onChange(element)"  :value="element.checkbox.checkedValue" :unchecked-value="element.checkbox.notCheckedValue" switch >  </b-form-checkbox>
							</template>
							<template v-if="element.type === 'span'">
								<span>{{ formData[element.modelName] }}</span>
							</template>
							<template v-if="element.type === 'calculate'">
								<b-form-input :disabled="true" v-model="formData[element.modelName]"></b-form-input>
							</template>
							<!-- <template v-if="element.type === 'table'">
								<div v-for="(gruppoItem, index) in gruppoItems(element)" :key="index">
									<p>{{ gruppoItem.label }}</p>
									<b-table sticky-header ref="table" stacked="sm" striped hover :items="gruppoItem.items" :fields="element.table.fields" :current-page="1" :per-page="1000000" sort-icon-left head-variant="light" class="sa-b-table" thead-class="hidden-header">
										<template #cell(fattore)="item">
											{{ item.item.fattore }}
										</template>
										<template #cell(check)="{ item }">
											<b-form-select
												v-if="item.inputType === 'SELECT'"
												id="inline-form-custom-select-pref"
												class="mb-2 mr-sm-2 mb-sm-0"
												v-model="item.punteggio"
												:value="null"
												value-field="value"
												text-field="text"
												:options="item.punteggioOptions"
												:disabled="isModalView"
												@change="onChangePunteggio(item)"
											>
												<template #first>
													<b-form-select-option :value="null" disabled> -Seleziona un'opzione- </b-form-select-option>
												</template>
											</b-form-select>
											<b-form-checkbox v-else v-model="item.check" :checked="item.check" :disabled="isModalView" switch></b-form-checkbox>
										</template>
									</b-table>
								</div>
							</template>-->
						</template>
						<template v-else>
							<span v-if="element.type === 'datepicker'">
								<template v-if="!element.typedetail">
								{{ formatDate(formData[element.modelName]) }}
								</template>
								<template v-else>
								{{ formatDateTime(formData[element.modelName]) }}
								</template>

							</span>

							<span v-else-if="element.type === 'select'">{{ selecText(element.dataOptions, formData[element.modelName]) }}</span>
							<span v-else-if="element.type === 'checkbox'">{{formData[element.modelName] }}</span>
							<span v-else>{{ formData[element.modelName] }}</span>
						</template>
					</b-col>
			</b-row>
		</b-card>
	</div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import UtilityMixin from "../UtilityMixin";
export default {
	props: {
		jsonData: { type: Object },
		isView: {
			type: Boolean,
			default: () => {
				return false;
			},
		},
     /*   preview:{
            type: Boolean,
			default: () => {
				return false;
			},
        }*/
	},
	mixins: [UtilityMixin],
	components: { DatePicker },
	data() {
		return {
			keyIndex: 0,
			renderingDatePicker: false,
			formData: {}, //{ dataOra: new Date().getTime() },
			sections: [],
			tablesItems: [],
			isModalView: false,
		};
	},
	created() {
		// this.jsonData.jsonForm.forEach((element) => {
		// 	console.log(element);
		// 	this.formData[element.modelName] = null;
		// });
	},
	mounted() {
		this.jsonData.jsonForm.forEach((element) => {
			if (element.type === "table") {
				this.loadDataTable(element);
			}
		});
	},
	computed: {},
	watch: {
		"jsonData.jsonForm": {
			handler(value) {
				let me = this;
                me.sections =[];
				Object.entries(value).forEach(([chiave, valore]) => {
					chiave;
					if (valore.type === "select") {
						this.$set(me.formData, valore.modelName, null);
					} else if (valore.type === "datepicker") {
						const timestamp = new Date().getTime();
						this.$set(me.formData, valore.modelName, timestamp);
					} else if (valore.type === "checkbox") {
						this.$set(me.formData, valore.modelName, valore.checkbox.notCheckedValue);
					}else if (valore.type === "input" && valore.typedetail =="number") {
						this.$set(me.formData, valore.modelName, 0);
					}else if (valore.type === "calculate") {						
						this.$set(me.formData, valore.modelName, 0);
					}
					let section;
					if (valore.sezione && valore.sezione != "base") {
						section = { sezione: valore.sezione, sezioneTitolo: valore.sezioneTitolo };
					} else {
						section = { sezione: "base", sezioneTitolo: this.jsonData.titolo };
					}
					this.sections.push(section);
				});
				this.sections = [...new Map(this.sections.map((item) => [item["sezione"], item])).values()];
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		gruppoItems(element) {
			let returnValue = [];
			let gruppiTmp = [];
			let pathName = process.env.VUE_APP_PATH_API + element.table.pathResources;
			let items = this.tablesItems[pathName] ? this.tablesItems[pathName].items : [];
			console.log(items);
			items.forEach((item) => {
				gruppiTmp.push(item[element.table.groupKeyItemName]);
			});
			console.log(gruppiTmp);
			gruppiTmp = [...new Set(gruppiTmp)];
			gruppiTmp.forEach((gruppo) => {
				returnValue.push({ label: gruppo, items: items.filter((el) => el[element.table.groupKeyItemName] === gruppo) });
			});

			return returnValue;
		},
		getItems(element) {
			let pathName = process.env.VUE_APP_PATH_API + element.table.pathResources;
			return this.tablesItems[pathName] ? this.tablesItems[pathName].items : [];
		},
		getJsonForm(sezione) {
			return this.jsonData.jsonForm.filter((e) => e.sezione === sezione.sezione || e.sezione === null);
		},
		selecText(array, valueElement) {
			//OTTIMO
			if (valueElement === null) return;
			if (!array) return;
			let returnValue = array.filter((a) => a.value == valueElement);
			return returnValue[0].text;
		},
		getDataFormattata(date) {
			let out = "";
			if (date) out = moment(new Date(date)).format("DD/MM/yyyy");
			return out;
		},
		getJsonData() {
			return this.formData;
		},
		setForm(value) {
			this.formData = {...value};
		},
		onChange(element) {
			switch (element.formula) {
				case "SUM":
					this.sum(element);
					break;
			}
		},
		sum(item) {
			this.formData[item.formulaResult] = 0;
			let sumElement = this.jsonData.jsonForm.filter((element) => element.formula === "SUM" && element.formulaResult === item.formulaResult);
			sumElement.forEach((el) => {
				let number = 0;
				if(el.type === "select" && el.typedetail === "samevalue"){
					let value = this.formData[el.modelName];
					if(value){
						
					const part = value.split("#");
					number = Number(part[0]);	
					}			
				}else{
					number = this.formData[el.modelName]
				}
			this.formData[item.formulaResult] += number;
				
			});
			this.keyIndex++;
		},
		loadDataTable(element) {
			let me = this;
			let pathName = process.env.VUE_APP_PATH_API + element.table.pathResources;
			this.tablesItems[pathName] = element;
			UtilityMixin.methods.loadDataResources(element.table.pathResources, {}, me.loadDataTableSuccess, me.loadDataTableError);
		},
		loadDataTableSuccess(response) {
			console.log(response.config.url);
			console.log(response);
			this.tablesItems[response.config.url].items = response.data.data.list;

			console.log(this.tablesItems);
			this.keyIndex++;
		},
		loadDataTableError(error) {
			console.log(error);
		},
	},
};
</script>

<style></style>
